import { ButtonV2, DialogV2, Flex } from '@withjoy/joykit';
import React, { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import { MessageStatus } from '../../CreditCardWidget/components/MessageStatus/MessageStatus';
import PoweredByStripe from '@assets/PoweredbyStripe.png';
import { useMount } from '@shared/utils/hooks/useMount';
import { useCreditCardSetupTelemetry } from '../CreditCardSetUp.telemetry';

interface OnboardingStatusProps {
  status: string;
  maxAttemptsReached: boolean;

  onboardingUrl: string;
}

export const OnboardingStatus: React.FC<OnboardingStatusProps> = ({ status, maxAttemptsReached, onboardingUrl }) => {
  const telemetry = useCreditCardSetupTelemetry();
  const { t2 } = useTranslation('sharedRegistry');
  const { checkStripeStatus } = t2('creditCardSetUpDialog');
  const currentStatus = useMemo(() => {
    if (status === 'pending' && maxAttemptsReached) {
      return 'warning';
    }

    return 'loading';
  }, [status, maxAttemptsReached]);

  useMount(() => {
    telemetry.creditCardSetupDialog.enter(status);
  });
  return (
    <>
      <DialogV2.Body>
        <Flex minHeight="432px" alignItems="center" justifyContent="center" flexDirection="column">
          <MessageStatus messageStatus={currentStatus} />
          {currentStatus !== 'loading' && (
            <ButtonV2 marginTop={9} variant="outline" shape="rounded" intent="neutral" onClick={() => window.open(onboardingUrl)}>
              {checkStripeStatus}
            </ButtonV2>
          )}
        </Flex>
      </DialogV2.Body>
      <DialogV2.Footer justifyContent="center">
        <Flex justifyContent="center" alignItems="center">
          <img src={PoweredByStripe} title="Stripe" alt="stripe" />
        </Flex>
      </DialogV2.Footer>
    </>
  );
};
